import { render, staticRenderFns } from "./TheDialog.vue?vue&type=template&id=2b2daa14"
import script from "./TheDialog.vue?vue&type=script&lang=js"
export * from "./TheDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports